import { styled, keyframes } from "@mui/material/styles";
export const tractionAIMainStyles = {
  title: {
    color: "#0b4f71",
    fontFamily: "lato-Bold"
  }
};
const blink = keyframes`
  0%, 100% { background-color: transparent; }
  50% { background-color: black; }
`;
const preloader = keyframes`
  to { transform: scale(2); }
`;
export const PUBLIC_AI_STYLED_ELEMENTS = {
  recommendationItem: styled("div")(() => ({
    cursor: "pointer",
    backgroundColor: "white",
    padding: "24px",
    borderRadius: "24px",
    height: "180px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "280px",
    maxWidth: "90%",
    gap: "16px",
    "&:hover": {
      border: "1px solid #616e7c"
    }
  })),
  recommendationItemText: styled("p")(() => ({
    fontSize: "20px",
    textAlign: "center",
    marginTop: "15px",
    fontFamily: "lato-bold"
  })),
  TypingText: styled("div")({
    whiteSpace: "pre-wrap",
    wordWrap: "break-word"
  }),
  TextContainer: styled("span")({
    display: "inline-block"
  }),
  Cursor: styled("span")(() => ({
    display: "inline-block",
    width: "2px",
    height: "1em",
    backgroundColor: "black",
    animation: `${blink} 1s step-end infinite`
  })),
  RandomLoaderWrapper: styled("div")({
    display: "flex",
    alignItems: "center"
  }),
  RandomLoaderText: styled("span")(_ref => {
    let {
      theme,
      size = "small"
    } = _ref;
    return {
      color: "#3994c1",
      fontFamily: "lato-bold",
      marginRight: 10,
      fontSize: {
        small: 15,
        medium: 18,
        big: 30
      }[size]
    };
  }),
  RandomLoaderDots: styled("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& > span": {
      borderRadius: "100%",
      border: "2px solid #3994c1",
      margin: "calc(2px * 2)",
      animationName: preloader,
      animationDuration: "0.6s",
      animationTimingFunction: "ease-in-out",
      animationDirection: "alternate",
      animationIterationCount: "infinite"
    },
    "& > span:nth-of-type(2)": {
      animationDelay: "0.2s"
    },
    "& > span:nth-of-type(3)": {
      animationDelay: "0.4s"
    }
  }),
  AITextArea: styled("textarea")(_ref2 => {
    let {
      theme
    } = _ref2;
    return {
      borderRadius: 7,
      padding: "7px 15px",
      width: "100%",
      border: "1px solid #e4e7eb",
      fontSize: 14,
      outline: "none",
      resize: "vertical",
      "&:focus": {
        borderColor: theme.palette.primary.main || "#3994c1",
        boxShadow: "0 0 0 2px rgba(57,148,193,0.20)"
      },
      "&:disabled": {
        backgroundColor: theme.palette.action.disabledBackground,
        color: theme.palette.text.disabled,
        cursor: "not-allowed"
      }
    };
  }),
  SearchByQuery: styled("div")(_ref3 => {
    let {
      theme
    } = _ref3;
    return {
      background: "white",
      padding: "5px 15px",
      borderRadius: 7,
      maxWidth: "70%",
      marginBottom: 15,
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%"
      }
    };
  }),
  AnimatedSectionRoot: styled("div", {
    shouldForwardProp: prop => !["animate", "delay", "disableTransition"].includes(prop)
  })(_ref4 => {
    let {
      animate = false,
      delay = 0,
      disableTransition = false
    } = _ref4;
    return {
      opacity: animate ? 1 : 0,
      transform: animate ? "translateY(0)" : "translateY(20px)",
      transition: disableTransition ? "none" : "opacity 0.8s ease-out, transform 0.8s ease-out",
      transitionDelay: disableTransition ? "0ms" : `${delay}ms`,
      willChange: "opacity, transform"
    };
  }),
  SwotWrapper: styled("div")(_ref5 => {
    let {
      theme
    } = _ref5;
    return {
      display: "flex",
      flexDirection: "column",
      marginBottom: theme.spacing(4),
      paddingLeft: 16,
      paddingRight: 16
    };
  }),
  SwotRow: styled("div")(_ref6 => {
    let {
      theme
    } = _ref6;
    return {
      display: "flex",
      flexDirection: "row",
      gap: 8,
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        gap: 12
      }
    };
  }),
  SwotSection: styled("div")(_ref7 => {
    let {
      theme
    } = _ref7;
    return {
      flex: "0 0 50%",
      display: "flex",
      flexDirection: "column",
      [theme.breakpoints.down("sm")]: {
        flex: "1 1 auto",
        width: "100%"
      }
    };
  }),
  SwotHeader: styled("div")(() => ({
    backgroundColor: "rgba(57, 148, 193, 0.47)",
    padding: "20px 0",
    display: "flex",
    alignItems: "center",
    fontSize: 18,
    fontFamily: "lato-bold",
    justifyContent: "center"
  })),
  SwotBody: styled("div")(() => ({
    borderBottom: "1px solid rgba(57, 148, 193, 0.47)",
    borderRight: "1px solid rgba(57, 148, 193, 0.47)",
    borderLeft: "1px solid rgba(57, 148, 193, 0.47)",
    padding: 15,
    height: "100%"
  })),
  SwotList: styled("ul")(() => ({
    marginBottom: 0,
    marginLeft: 16,
    paddingLeft: 16
  })),
  TrendWrapper: styled("div")(_ref8 => {
    let {
      theme
    } = _ref8;
    return {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      marginBottom: theme.spacing(4),
      paddingLeft: 16,
      paddingRight: 16
    };
  }),
  TrendCol: styled("div")(_ref9 => {
    let {
      theme
    } = _ref9;
    return {
      boxSizing: "border-box",
      width: "50%",
      paddingLeft: 8,
      paddingRight: 8,
      marginBottom: theme.spacing(1),
      [theme.breakpoints.down("sm")]: {
        width: "100%"
      }
    };
  }),
  TrendSection: styled("div")(() => ({
    width: "100%",
    display: "flex",
    flexDirection: "column"
  })),
  TrendHeader: styled("div")(() => ({
    backgroundColor: "rgba(57, 148, 193, 0.47)",
    padding: "20px 15px",
    display: "flex",
    alignItems: "center",
    fontSize: 18,
    fontFamily: "lato-bold",
    justifyContent: "center",
    textAlign: "center"
  })),
  TrendBody: styled("div")(() => ({
    borderBottom: "1px solid rgba(57, 148, 193, 0.47)",
    borderRight: "1px solid rgba(57, 148, 193, 0.47)",
    borderLeft: "1px solid rgba(57, 148, 193, 0.47)",
    padding: 15,
    height: "100%"
  })),
  TrendList: styled("ul")(() => ({
    marginBottom: 0,
    marginLeft: 16,
    paddingLeft: 16
  }))
};